import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import packageJson from '../../package.json';

/**
 * Get app version info across all platforms
 * - Web: reads from package.json
 * - iOS/Android: reads from native config via react-native-device-info
 */
export function getAppVersion(): string {
  if (Platform.OS === 'web') {
    return packageJson.version || '0.0.0';
  }
  return DeviceInfo.getVersion();
}

export function getBuildNumber(): string {
  if (Platform.OS === 'web') {
    // Web doesn't have a separate build number, use version
    return packageJson.version || '0.0.0';
  }
  return DeviceInfo.getBuildNumber();
}

export function getPlatformName(): string {
  switch (Platform.OS) {
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    case 'web':
      return 'Web';
    default:
      return Platform.OS;
  }
}

export function getVersionDisplay(): string {
  const version = getAppVersion();
  const buildNumber = getBuildNumber();

  // On web, version and build are the same, so don't show duplicate
  if (Platform.OS === 'web' || version === buildNumber) {
    return `v${version}`;
  }

  return `v${version} (${buildNumber})`;
}
